import { z } from 'zod';

/**
 * We use BCP-47 language tags (i.e. the format used for the HTML lang attribute).
 *
 * These are the languages supported for AI generation.  The UI is always in English.
 *
 * KEEP IN ALPHABETICAL ORDER thank you
 **/
export const localeSchema = z.enum([
  'bg-BR', // TODO:This is a typo, should be 'bg-BG'
  'cs-CZ',
  'de-DE',
  'da-DK',
  'en-GB',
  'en-US',
  'es-ES',
  'fi-FI',
  'fr-FR',
  'hi-IN',
  'hr-BA',
  'hr-HR',
  'hu-HU',
  'id-ID',
  'it-IT',
  'ja-JP',
  'ko-KR',
  'ne-NP',
  'nl-NL',
  'no-NO',
  'pl-PL',
  'pt-BR',
  'ro-RO',
  'ru-RU',
  'sk-SK',
  'sv-SE',
  'tl-PH',
  'uk-UA',
  'vi-VN',
  'zh-CN',
  'zh-TW',
]);
export type Locale = z.infer<typeof localeSchema>;

export const DEFAULT_LOCALE: Locale = 'en-US';

// Use Language Name (Local) from https://simplelocalize.io/data/locale-code/bg-BG/
export const LOCALE_INFO: Record<
  Locale,
  { name: string; searchSynonyms?: string }
> = {
  'bg-BR': {
    name: 'български език',
    searchSynonyms: 'Bulgarian',
  },
  'cs-CZ': {
    name: 'Čeština',
    searchSynonyms: 'Czech',
  },
  'de-DE': {
    name: 'Deutsch',
    searchSynonyms: 'German',
  },
  'da-DK': {
    name: 'Dansk',
    searchSynonyms: 'Danish',
  },
  'en-GB': {
    name: 'English (UK)',
  },
  'en-US': {
    name: 'English (US)',
  },
  'es-ES': {
    name: 'Español',
    searchSynonyms: 'Spanish',
  },
  'fi-FI': {
    name: 'Suomi',
    searchSynonyms: 'Finnish',
  },
  'fr-FR': {
    name: 'Français',
    searchSynonyms: 'French Francais',
  },
  'hi-IN': {
    name: 'हिन्दी',
    searchSynonyms: 'Hindi',
  },
  'hu-HU': {
    name: 'Magyar',
    searchSynonyms: 'Hungarian',
  },
  'id-ID': {
    name: 'Bahasa Indonesia',
    searchSynonyms: 'Indonesian',
  },
  'hr-BA': {
    name: 'hrvatski (Bosna i Hercegovina)',
    searchSynonyms: 'Croatian (Bosnia and Herzegovina)',
  },
  'hr-HR': {
    name: 'hrvatski (Hrvatska)',
    searchSynonyms: 'Croatian (Croatia)',
  },
  'it-IT': {
    name: 'Italiano',
    searchSynonyms: 'Italian',
  },
  'ja-JP': {
    name: '日本語',
    searchSynonyms: 'Japanese',
  },
  'ko-KR': {
    name: '한국어',
    searchSynonyms: 'Korean',
  },
  'ne-NP': {
    name: 'नेपाली',
    searchSynonyms: 'Nepali',
  },
  'nl-NL': {
    name: 'Nederlands',
    searchSynonyms: 'Dutch',
  },
  'no-NO': {
    name: 'Norsk',
    searchSynonyms: 'Norwegian',
  },
  'pl-PL': {
    name: 'Polski',
    searchSynonyms: 'Polish',
  },
  'pt-BR': {
    name: 'Português (BR)',
    searchSynonyms: 'Portuguese Brazil',
  },
  'ro-RO': {
    name: 'Română',
    searchSynonyms: 'Romanian',
  },
  'ru-RU': {
    name: 'Русский',
    searchSynonyms: 'Russian',
  },
  'sk-SK': {
    name: 'Slovenčina',
    searchSynonyms: 'Slovak',
  },
  'sv-SE': {
    name: 'Svenska',
    searchSynonyms: 'Swedish',
  },
  'tl-PH': {
    name: 'Tagalog',
    searchSynonyms: 'Filipino',
  },
  'uk-UA': {
    name: 'Українська',
    searchSynonyms: 'Ukrainian',
  },
  'vi-VN': {
    name: 'Tiếng Việt',
    searchSynonyms: 'Vietnamese',
  },
  'zh-CN': {
    name: '中文 (简体)',
    searchSynonyms: 'Chinese Simplified Chinese',
  },
  'zh-TW': {
    name: '中文 (繁體)',
    searchSynonyms: 'Chinese Traditional Chinese',
  },
};
